/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BrokerageInputs */

const en_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokerage`)
};

const es_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corretaje`)
};

const fr_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courtage`)
};

const de_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokerage`)
};

const ja_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仲介`)
};

const zh_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游艇经纪`)
};

const ar_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وساطة (Brokerage)`)
};

const id_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pialang`)
};

const it_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediazione (Brokerage)`)
};

const ru_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брокерские услуги`)
};

const pt_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corretagem`)
};

const ko_val_brokerage = /** @type {(inputs: Val_BrokerageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브로커리지(중개)`)
};

/**
* | output |
* | --- |
* | "Brokerage" |
*
* @param {Val_BrokerageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_brokerage = /** @type {((inputs?: Val_BrokerageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BrokerageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_brokerage(inputs)
	if (locale === "es") return es_val_brokerage(inputs)
	if (locale === "fr") return fr_val_brokerage(inputs)
	if (locale === "de") return de_val_brokerage(inputs)
	if (locale === "ja") return ja_val_brokerage(inputs)
	if (locale === "zh") return zh_val_brokerage(inputs)
	if (locale === "ar") return ar_val_brokerage(inputs)
	if (locale === "id") return id_val_brokerage(inputs)
	if (locale === "it") return it_val_brokerage(inputs)
	if (locale === "ru") return ru_val_brokerage(inputs)
	if (locale === "pt") return pt_val_brokerage(inputs)
	return ko_val_brokerage(inputs)
});